import type { SchedulerSummary } from '@/api/types'

// A run's history row is written once its HTTP call returns, so the next send lands a little after the period.
const GRACE_MS = 60_000

/** Late once no job was sent for longer than the period of the most frequent active job, plus a minute's grace. */
export function isSendLate(summary: SchedulerSummary, now = Date.now()): boolean {
  if (summary.shortestPeriodMinutes === null) return false
  if (!summary.lastSentAt) return true
  return now - new Date(summary.lastSentAt).getTime() > summary.shortestPeriodMinutes * 60_000 + GRACE_MS
}

/** "15 min", "2 h", "1 day", "3 days". */
export function formatPeriod(minutes: number): string {
  if (minutes % 1440 === 0) return minutes === 1440 ? '1 day' : `${minutes / 1440} days`
  if (minutes % 60 === 0) return `${minutes / 60} h`
  return `${minutes} min`
}
